export const REMINDER_NUDGE_MODES = ['phrase', 'grammar', 'listening'] as const;

export type ReminderNudgeModeType = (typeof REMINDER_NUDGE_MODES)[number];

export const REMINDER_NUDGE_MODE_ROUTES: Record<ReminderNudgeModeType, string> = {
  phrase: '/stage',
  grammar: '/grammar',
  listening: '/listening',
};

export const REMINDER_NUDGE_MODE_LABELS: Record<ReminderNudgeModeType, string> = {
  phrase: 'Start Challenge',
  grammar: 'Start Grammar Workout',
  listening: 'Start Listening Gym',
};

export const REMINDER_SITUATIONS = [
  'streakRescue',
  'streakGuard',
  'comeback',
  'pileUp',
  'phrase',
  'grammar',
  'listening',
] as const;

export type ReminderSituationType = (typeof REMINDER_SITUATIONS)[number];

export const REMINDER_DAYPARTS = [
  'earlyMorning',
  'morning',
  'afternoon',
  'evening',
  'night',
] as const;

export type ReminderDaypartType = (typeof REMINDER_DAYPARTS)[number];
